import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { PrimaryBtn, SecondaryBtn } from '@root-gipro/shared/Button/Button'
import { IRegion, IState } from '@root-gipro/store/interfaces'
import React, { ReactText, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import './Region.scss'

interface RegionProps {
	anchorEl: (EventTarget & HTMLElement) | null
	setAnchorEl(event: HTMLElement): void
	handler(regionId: string | null, zoneId?: string | null): void
	regionList: IRegion[]
	checkedRegionId: ReactText | null
	setCheckedRegion: (id: ReactText | null) => void
	checkedZoneId: string | null
	setCheckedZoneId: (id: string | null) => void
}

const Region: React.FC<RegionProps> = ({
	anchorEl,
	setAnchorEl,
	handler,
	regionList,
	setCheckedRegion,
	checkedRegionId,
	checkedZoneId,
	setCheckedZoneId,
}) => {
	const [selectedRegion, setSelectedRegion] = useState<IRegion | null>(null)
	const [hasRegionZone, setHasRegionZone] = useState(false)
	const [allowedZoneIds, setAllowedZoneIds] = useState<number[]>([])
	const { activeUncs, uncs, projectObj } = useSelector((state: IState) => state.userProjects)
	const { regions } = useSelector((state: IState) => state.public)

	useEffect(() => {
		const activeUncId = anchorEl?.dataset?.region
		if(activeUncId){
			const unc = uncs.find((item)=>item.id == activeUncId)
			if(!unc?.region_zone_id){
				setAllowedZoneIds([])
			}
			else if (projectObj.regionZoneIds) {
				setAllowedZoneIds(projectObj.regionZoneIds)
			}
		}
	}, [])

	const handleZoneClick = (zoneId: string) => {
		if (selectedRegion?.region_zones.length === 1) {
			return
		}
		setCheckedZoneId(zoneId)
	}
	const handleRegClick = (regId: string) => {
		const selected = regionList.find(elem => elem.id === regId)
		setSelectedRegion(selected || null)
		setCheckedZoneId(null)

		if (selected) {
			setSelectedRegion(selected)

			if (selected?.region_zones.length > 0) {
				const firstZoneId = selected.region_zones[0].id
				setCheckedZoneId(firstZoneId)
			} else {
				setCheckedZoneId(null)
			}

			if (checkedRegionId === regId) {
				setCheckedRegion(null)
			} else {
				setCheckedRegion(regId)
			}
		}

		uncs.map(unc => {
			if (activeUncs[0].id === unc.id && unc.regionId === regId && unc.region_zone_id && selected?.region_zones) {
				setCheckedZoneId(unc.region_zone_id)
			}
		})
	}

	const handleClose = () => {
		setAnchorEl!(null!)
		setSelectedRegion(null)
	}

	const handleConfirm = (regionId: string) => {
			handleRegClick(regionId)
			handler(regionId as string)
			localStorage.setItem(
				'selectedRegion',
				JSON.stringify({ regionId: regionId })
			)
		handleClose()
	}

	function getRegionIdByZoneId(zoneId: string | string): string | null {
		for (const region of regions) {
			if (region.region_zones?.some((zone: any) => zone.id === zoneId)) {
				return region.id
			}
		}
		return null
	}

	const handleConfirmWithRegionZone = (zoneId: string) => {
		const regionId = getRegionIdByZoneId(zoneId)

		localStorage.setItem('selectedRegion', JSON.stringify({ zoneId, regionId }))
		handler(regionId, zoneId)
	}
	return (
		<>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				{allowedZoneIds.length
					? regions.map(region => (
							<div key={region.id}>
								{region.region_zones
									?.filter((zone: { id: string; name: string }) => allowedZoneIds.includes(Number(zone.id)))
									?.map((zone: { id: string; name: string }) => (
										<MenuItem key={zone.id} onClick={() => handleConfirmWithRegionZone(zone.id)}>
											{zone.name}
										</MenuItem>
									))}
							</div>
					  ))
					: // 🔁 Старая логика — просто список регионов
					  regionList.map(elem => (
							<MenuItem key={elem.id} onClick={() => handleConfirm(elem.id)}>
								{elem.name}
							</MenuItem>
					  ))}
			</Menu>

		</>
	)
}

export default Region
